import React, { useEffect } from "react";
import DOMPurify from "dompurify";
import "./styles.scss";

const HtmlPreview = ({ htmlContent, mode, className }) => {
  const sanitizedContent = DOMPurify.sanitize(htmlContent);

  useEffect(() => {
    if (mode === "card") {
      // Garante que o MathJax processe o conteúdo do card após renderização
      if (window.MathJax) {
        setTimeout(() => {
          window.MathJax.typesetPromise().catch((err) =>
            console.error(err.message)
          );
        }, 1000); // Ajuste o tempo se necessário
      }
    }
  }, [sanitizedContent, mode]);

  if (mode === "list") {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = sanitizedContent;

    let textContent = tempDiv.textContent || tempDiv.innerText || "";
    textContent = textContent.replace(/[\r\n]+/g, " ").trim();
    textContent = textContent
      .replace(/Disponível em: www.*?\.(\s+|$)/g, "")
      .replace(/Fonte: .*?\.(\s+|$)/g, "")
      .replace(/\\\(.*?\\\)/g, "")
      .trim();

    const firstSentence = textContent.split(".")[0] + ".";

    return <p className={className}>{firstSentence}</p>;
  } else if (mode === "card") {
    return (
      <div
        className={`${className} html-preview`}
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
    );
  }

  return null;
};

export default HtmlPreview;
